<template>
    <div>
        <div class="columns">
            <div class="column">
                <e-field>
                    <display-content :content="activityContent.content" />
                </e-field>
            </div>
        </div>

        <!-- TODO feature/lti-certification: handle submissions and disabling. -->
        <div class="columns">
            <div class="column">
                <e-loading v-model="loading" :is-full-page="false" />

                <div v-if="!loading">
                    <p class="content">{{ resourceLink.description }}</p>

                    <lti-resource-link-launcher :link="resourceLink" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

import DisplayContent from '@/components/editor/DisplayContent.vue';
import LtiResourceLinkLauncher from '@/components/lti/LtiResourceLinkLauncher.vue';
import AttemptAuthorizationMixin from '@/mixins/AttemptAuthorization.mixin.js';
import CourseActivityMixin from '@/mixins/CourseActivity.mixin.js';
import IsLateMixin from '@/mixins/IsLate.mixin.js';
import LtiResourceLink from '@/models/LtiResourceLink.js';
import axios from '@/plugins/axios.js';

export default {
    name: 'LtiResourceLink',

    components: { LtiResourceLinkLauncher, DisplayContent },

    mixins: [IsLateMixin, CourseActivityMixin, AttemptAuthorizationMixin],

    data() {
        return { loading: true, resourceLink: null };
    },

    computed: {
        ...mapState('Auth', { authUser: state => state.user }),

        id() {
            return this.$store.getters[`${this.namespace}/get`](this.uuid).id;
        },

        resource() {
            return this.namespace === 'Activities' ? 'activities' : 'activity-templates';
        },

        payload() {
            return {
                uuid: this.activity.uuid,
                course_id: this.courseId,
                activity_id: this.activityId,
                activity_type: this.get('activity_type'),
                activity_submission: [],
            };
        },
    },

    async created() {
        const { data } = await axios.get(`/api/${this.resource}/${this.id}?include=contentable.ltiResourceLink`);

        const rawResourceLink = data.data.activity_content.lti_resource_link;

        await LtiResourceLink.insert({ data: rawResourceLink });

        this.resourceLink = LtiResourceLink.query().with(['deployment', 'deployment.tool']).find(rawResourceLink.id);

        this.loading = false;
    },
};
</script>
